import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<App data-id="element-13" />} data-id="element-12" />
        <Route path="/blog" element={<BlogPage data-id="element-15" />} data-id="element-14" />
        <Route path="/blog/:id" element={<BlogPostPage data-id="element-17" />} data-id="element-16" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-19" />} data-id="element-18" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-21" />} data-id="element-20" />
        <Route path="/terms" element={<TermsPage data-id="element-23" />} data-id="element-22" />
      </Routes>
    </BrowserRouter>;
}